import React from 'react'
import { connect } from 'react-redux';
import reject from 'lodash/reject'
import find from 'lodash/find'
import { FormGroup, FormControl, Row, Col } from 'react-bootstrap'
import Multiselect from 'react-widgets/lib/Multiselect';
import { browserHistory } from 'react-router';
import Spinner from 'react-spinkit';

import StudentSteps from '../common/StudentSteps';
import { getCoursesObjsByIds } from '../../actions/commonActions'
import { getStudent, getWaitlist, getAssignment } from '../../actions/studentsActionCreators'
import { getRun, getAllRankPreferences } from '../../actions/runsActionCreators'
import { addToAutoDrop, getAllCourses, createAdd, refreshValidity } from '../../actions/coursesActionCreators'

class StudentJoinWaitlistPage extends React.Component {
  state = {
    confirmValue: '',
    selected: [],
    dataLoaded: false,
    disabled: false
  }

  componentWillMount() {
    const promises = [Promise.resolve()]

    if (!this.props.assignments.length) {
      promises.push(this.props.getAssignment())
    }

    if (!this.props.run.id) {
      promises.push(this.props.getRun())
    }
    if (!this.props.student.id) {
      promises.push(this.props.getStudent())
    }
    if (this.props.courses.length === 0) {
      promises.push(this.props.getAllCourses().then(() => {
      }))
    }
    if (!this.props.waitlist.isFetched && !this.props.waitlist.isOnFetch) {
      promises.push(this.props.getWaitlist())
    }

    Promise.all(promises).then(() => {
      this.setState({ dataLoaded: true })
    })
  }

  handleConfirmChange = ({ target: { value } }) => {
    this.setState({
      confirmValue: value,
      disabled: value !== 'SET'
    })
  }

  handleChange = value => {
    this.setState({
      selected: value,
      disabled: value.length > 0 && this.state.confirmValue !== 'SET'
    })
  }

  handleClose = (/*event*/) => {
      browserHistory.push(`/rank/${this.props.run.slug}/find-classes`)
  }

  handleSubmit = (event) => {
    event.preventDefault()

    this.props.createAdd(this.props.courseId).then((newAssignment) => {
      if (newAssignment.id) {
        this.props.refreshValidity(newAssignment.id).then(() => {
          this.props.getWaitlist()
        });
      }
      console.log(newAssignment);
      if (this.state.selected.length) {
        return new Promise((resolve) => {
          this.props.getWaitlist().then((waitlists) => {
            const waitlistId = find(waitlists, { course: +this.props.courseId }).id

            this.props.addToAutoDrop({
              addId: waitlistId,
              ids: this.state.selected.map(item => {
                return find([...this.props.assignments, newAssignment], { course: item.id }).id
              })
            }).then(resolve)
          })
        })
      }
    })
    .then(() => {
      browserHistory.push(`/rank/${this.props.run.slug}/find-classes`)
    })
  }

  render() {
    if (!this.state.dataLoaded) {
      return (
        <div className="spinner-box">
          <Spinner spinnerName="three-bounce" className="mt-4" />
        </div>
      )
    }

    const { courseName, courseId, courseSlug } = this.props

    const {
      disabled,
      confirmValue,
      selected
    } = this.state
    const { assignmentCourses } = this.props
    const allAssignmentCourses = assignmentCourses.map(item => {
      return {
        slug: item.slug,
        id: item.id
      }
    })
    let multiselectAutoDropData = []
    // console.debug(`[this.props.courses] - ${JSON.stringify(this.props.courses, null, 2)}`)
    if (courseId) {
      multiselectAutoDropData =
        reject(allAssignmentCourses, item => {
          return item.id === (find(this.props.waitlist.data, item => item.id === courseId) || {}).course
        }).map(c => {
          const course = this.props.courses.find(x => x.id === c.id)
          const name = course ? course.longname : '(No Name)'
          return {
            ...c,
            msText: `${c.slug} - ${name.length ? name : '(No Name)'}`
          }
        })
    }

    return (
      <div className="student-join-waitlist-page">
        <Row>
          <Col md={8}>
            <div className="page-title">Join Waitlist</div>
            <StudentSteps isAssignmentCompleted={true} />
            <div>
              <header className="header">
                <div className="header-title">
                  Waitlist request:{' '}{ courseName } ({courseSlug})
                </div>
              </header>
              <h4>Do you want to add a conditional drop (optional)?</h4>
              <p className="mt-2">
                You will be automatically dropped from these classes if your waitlist request is successful.
                A conditional drop may be needed to avoid issues like conflicts or credit limits.
              </p>
              <form onSubmit={this.handleSubmit}>
                <div className="body mt-1">
                  <Multiselect
                    data={multiselectAutoDropData}
                    value={selected}
                    textField="msText"
                    valueField="id"
                    onChange={this.handleChange}
                  />
                  <p className="mt-2">
                    Type <span className="textColorPurple">SET</span> to confirm.
                  </p>
                  <FormGroup controlId="formControlsConfirmAutoDropInputValue">
                    <FormControl
                      componentClass="input"
                      value={confirmValue}
                      onChange={this.handleConfirmChange}
                      placeholder="SET"
                    />
                  </FormGroup>
                </div>
                <footer className="footer border-none mt-0">
                  <div className="buttonsSpaceBetween">
                    <button className="btn btn-ter" type="button" onClick={this.handleClose}>
                      Cancel
                    </button>
                    <button className="btn btn-primary" type="submit" disabled={disabled}>
                      Join Waitlist
                    </button>
                  </div>
                </footer>
              </form>
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

function mapDispatchToProps() {
  return {
    createAdd,
    addToAutoDrop,
    getStudent,
    getWaitlist,
    getRun,
    getAllRankPreferences,
    getAllCourses,
    getAssignment,
    refreshValidity
  }
}

function mapStateToProps (state, ownProps) {
  return {
    courseId: ownProps.routeParams.id,
    run: state.run,
    student: state.student,
    courses: state.courses,
    courseName: (find(state.courses, {id: +ownProps.routeParams.id}) || {}).longname,
    courseSlug: (find(state.courses, {id: +ownProps.routeParams.id}) || {}).slug,
    waitlist: state.waitlist,
    assignments: state.assignments,
    assignmentCourses: state.student.assignments
      ? getCoursesObjsByIds(state.student.assignments.map(item => item.course), state.courses)
      : []
  }
}


export default connect(mapStateToProps, mapDispatchToProps())(StudentJoinWaitlistPage)


// WEBPACK FOOTER //
// ./src/components/rank/StudentJoinWaitlistPage.js